import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useCurrentRoute() {
  var _a = React.useContext(NaviContext),
      steadyRoute = _a.steadyRoute,
      busyRoute = _a.busyRoute;

  return steadyRoute || busyRoute;
}
export function CurrentRoute(props) {
  React.useEffect(function () {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("Deprecation Warning: \"<CurrentRoute>\" is deprecated. From Navi 0.14, " + "you'll need to use the \"useCurrentRoute()\" hook instead.");
    }
  }, []);
  return React.createElement(NaviContext.Consumer, null, function (context) {
    return props.children(context.steadyRoute || context.busyRoute);
  });
}